import { connect, useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router';
import { RootStateType } from '../redux-store/reducers';
import { AuthRoutePropsType } from './ProtectedRoute';

function RedirectRoute({ component: Component, path = '', ...rest }: AuthRoutePropsType) {
  const { token, arn_link } = useSelector((store: RootStateType) => store.preventLogoutReducer);
  const loggedOutRedirectURI =
    arn_link && token
      ? `?token=${token}&arn_link=${arn_link}`
      : token
      ? `?token=${token}`
      : arn_link
      ? `?arn_link=${arn_link}`
      : '';
  return (
    <Route
      {...rest}
      render={(props) => {
        console.log('RedirectRoute props', props, path, rest);
        return rest.isLoggedIn ? (
          <Redirect to="/" from={props.location.pathname} />
        ) : (
          //  path.includes('/investor-signup') || path.includes('/investor-login') ? (
          //   <Redirect
          //     to={{
          //       pathname: path,
          //       search: loggedOutRedirectURI,
          //       state: { from: location },
          //     }}
          //   />
          // ) :
          <Component {...props} />
        );
      }}
    />
  );
}

export default connect(({ auth }: RootStateType) => {
  return { isLoggedIn: !!auth.token };
}, {})(RedirectRoute);
